import { render, staticRenderFns } from "./MiniWizardStickyPrice.vue?vue&type=template&id=c1172e6a&"
import script from "./MiniWizardStickyPrice.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports